import {
    NgModule,
    ApplicationRef,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import {
    removeNgStyles,
    createNewHosts,
    createInputTransfer,
} from '@angularclass/hmr';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';

import { DirectivesModule } from '../components/directives.module';
import { JwtModule } from '@auth0/angular-jwt';
import { AccountModule } from './account/account.module';
import { MRAccountModule } from './mraccount/mraccount.module';
import { AdminModule } from './admin/admin.module';
import { MainModule } from './main/main.module';
// import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderModule, NgxUiLoaderRouterModule, NgxUiLoaderHttpModule, NgxUiLoaderConfig, POSITION, SPINNER, PB_DIRECTION } from  'ngx-ui-loader';
import { SelectivePreloadingStrategyService } from "./main/selective-preloading-strategy-service";
// import {
//     MatButtonModule,
//     MatFormFieldModule,
//     MatInputModule,
//     MatRippleModule,
// } from '@angular/material';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {AppServiceService} from './main/services/product.service';
import {MainMenuService} from './main/services/menuservice.service';
import { MrService } from '../components/auth/mr.service';
import { CustomerAdapter, SalesmanAdapter, DocTypeAdapter, DiscountType, DiscountTypeAdapter, PaymentTermsAdapter, TradingAccountsAdapter, uomAdapter, vendorAdapter } from './shared/models/';

import { AuthGardService } from '../app/authgard.service';
import { AgGridModule } from 'ag-grid-angular';
import { ActionButtonsRendererComponent } from './main/masters/action-buttons-renderer.component';
import { ActionGeneratepobtnRendererComponent } from './main/masters/action-genaratepobtn-renderer.component';

export function tokenGetter() {
    return localStorage.getItem('id_token');
}

const appRoutes: Routes = [{
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
}];

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    bgsSize: 0,
    fgsSize: 0,
    overlayColor: 'rgba(255,255,255,0.5)',
    pbColor: '#0773bc',
  };

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
        NgxUiLoaderRouterModule, // import this module for showing loader automatically when navigating between app routes
        NgxUiLoaderHttpModule,
        JwtModule.forRoot({
            config: {
                tokenGetter,
            }
        }),
        // RouterModule.forRoot(appRoutes, { enableTracing: process.env.NODE_ENV === 'development' }),
        RouterModule.forRoot(appRoutes, {
            enableTracing: false, preloadingStrategy: SelectivePreloadingStrategyService
        }),
        DirectivesModule,
        AccountModule,
        MRAccountModule,
        AdminModule,
        MainModule,
        // NgbModule,
        // MaterialModule,
        BrowserAnimationsModule,
        AgGridModule.withComponents([ActionButtonsRendererComponent,ActionGeneratepobtnRendererComponent])
    ],
    exports: [BrowserModule],
    declarations: [
        AppComponent,
        ActionButtonsRendererComponent,
        ActionGeneratepobtnRendererComponent
    ],
    bootstrap: [AppComponent],
    providers: [
        AppServiceService,
        MainMenuService,
        CustomerAdapter,
        SalesmanAdapter,
        DocTypeAdapter,
        DiscountTypeAdapter,
        PaymentTermsAdapter,
        TradingAccountsAdapter,
        uomAdapter,
        vendorAdapter,
        MrService,
        AuthGardService
    ],
    entryComponents: [
        ActionButtonsRendererComponent,
        ActionGeneratepobtnRendererComponent
    ]
})
export class AppModule {
    static parameters = [ApplicationRef];
    constructor(private appRef: ApplicationRef) {
        this.appRef = appRef;
    }

    hmrOnInit(store) {
        if (!store || !store.state) return;
        // console.log('HMR store', store);
        // console.log('store.state.data:', store.state.data);
        // inject AppStore here and update it
        // this.AppStore.update(store.state)
        if ('restoreInputValues' in store) {
            store.restoreInputValues();
        }
        // change detection
        this.appRef.tick();
        Reflect.deleteProperty(store, 'state');
        Reflect.deleteProperty(store, 'restoreInputValues');
    }

    hmrOnDestroy(store) {
        var cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
        // recreate elements
        store.disposeOldHosts = createNewHosts(cmpLocation);
        // inject your AppStore and grab state then set it on store
        // var appState = this.AppStore.get()
        store.state = { data: 'yolo' };
        // store.state = Object.assign({}, appState)
        // save input values
        store.restoreInputValues = createInputTransfer();
        // remove styles
        // removeNgStyles();
    }

    hmrAfterDestroy(store) {
        // display new elements
        store.disposeOldHosts();
        // delete store.disposeOldHosts;
        Reflect.deleteProperty(store, 'disposeOldHosts');
        // anything you need done the component is removed
    }
}
